import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

interface BookingCalendarProps {
  onBook: (date: Date) => void;
  isLoading?: boolean;
}

const BookingCalendar: React.FC<BookingCalendarProps> = ({ onBook, isLoading }) => {
  const { t } = useTranslation();
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  return (
    <div className="space-y-4">
      <DatePicker
        selected={selectedDate}
        onChange={(date: Date | null) => date && setSelectedDate(date)}
        minDate={new Date()}
        className="w-full p-2 border rounded"
        placeholderText={t('booking.selectDate', 'Seleziona data di prenotazione')}
      />
      <button
        onClick={() => selectedDate && onBook(selectedDate)}
        disabled={!selectedDate || isLoading}
        className="w-full px-4 py-2 bg-blue-600 text-white rounded disabled:opacity-50"
      >
        {isLoading ? t('booking.processing', 'Elaborazione...') : t('booking.bookNow', 'Prenota Ora')}
      </button>
    </div>
  );
};

export default BookingCalendar; 